import * as React from 'react';
import { Nav } from './widgets/Nav';
import { footer } from './widgets/Footer';
import { Saveable, SaveableState } from './widgets/Saveable';

import clients from './img/panel/clients.png';
import consultants from './img/panel/consultants.png';
import proposals from './img/panel/proposals.png';
import calendar from './img/panel/calendar.png';
import lock from './img/panel/lock.png';
import profiles from './img/panel/profiles.png';
import adminLogo from './img/panel/admin.png';
import contract from './img/panel/contract.png';
import { CustomerProposals } from './widgets/CustomerProposals';

export interface Props {
    superAdmin: boolean;
    accountType: string;
}

export class Panel extends Saveable<Props, SaveableState> {
    constructor(props: Props) {
        super(props);
        this.state = {saved: true};
    }
    render(): any {
        const {accountType, superAdmin} = this.props;
        const admin = accountType === 'admin';
        const consultant = accountType === 'consultant';
        const client = accountType === 'client';
        return (
            <div className="container">
                <Nav />
                {admin ? (
                    <div>
                        <div className="row">
                            <div className="col-4">
                                <div className="subpanel">
                                    <a href="/#/consultants">
                                        <img src={consultants} style={{width: '150px', marginTop: '30px', marginBottom: '30px'}} /> <br />
                                        Manage Consultants
                                    </a>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="subpanel">
                                    <a href="/#/clients">
                                        <img src={clients} style={{width: '150px'}} /> <br />
                                        Manage Customers
                                    </a>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="subpanel">
                                    <a href="/#/proposals">
                                        <img src={proposals} style={{width: '150px'}} /> <br />
                                        Manage Proposals
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
                {superAdmin ? (
                    <div>
                        <div className="row">
                            <div className="col-4">
                                <div className="subpanel">
                                    <a href="/#/admins">
                                        <img
                                            src={adminLogo}
                                            style={{width: '150px', opacity: 0.7}}
                                        /> <br />
                                        Manage Admins
                                    </a>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="subpanel">
                                    <a href="/#/contracts">
                                        <img
                                            className="ml-3 mb-2"
                                            src={contract}
                                            style={{width: '130px', opacity: 0.7}}
                                        /> <br />
                                        Manage Contracts
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
                {consultant ? (
                    <div>
                        <div className="row">
                            <div className="col-4">
                                <div className="subpanel">
                                    <a href="/#/availabilityCalendar">
                                        <img src={calendar} style={{width: '150px', marginTop: '10px', marginBottom: '48px'}} /> <br />
                                        My Availability
                                    </a>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="subpanel">
                                    <a href="/#/profileVersions">
                                        <img src={profiles} style={{width: '150px', marginBottom: '26px'}} /> <br />
                                        My Profiles
                                    </a>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="subpanel">
                                    <a href="/#/selfProfile">
                                        <img src={lock} style={{width: '150px', marginBottom: '37px'}} /> <br />
                                        My Account
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
                {client ? <CustomerProposals /> : null}
                {footer(this.props.accountType)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Panel.tsx